import React from 'react';
import PropTypes from 'prop-types';
import { TableBody } from '@mui/material';
import FinancialProductRulesEditDetailsOutputDictionariesTableRow from './FinancialProductRulesEditDetailsOutputDictionariesTableRow';
import { useTranslation } from 'react-i18next';
import { isValid } from '@totalsoft/pure-validations-react';
import { Typography } from '@totalsoft/rocket-ui';
import { sequence, get } from '@totalsoft/change-tracking-react';
import { StyledTableRow } from 'components/common/Styles';

const FinancialProductRulesEditDetailsOutputDictionariesTableBody = ({
  canWrite,
  financialProductRuleOutputDictionaryParamList,
  outputDictionariesList,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleOutputDictionaryValidation
}) => {
  const [t] = useTranslation();

  return (
    <TableBody>
      {!isValid(financialProductRuleOutputDictionaryValidation) &&
        !sequence(outputDictionariesList)?.find((_, index) => {
          return !isValid(financialProductRuleOutputDictionaryValidation[index]);
        }) && (
          <StyledTableRow>
            <Typography color='error'>{t('FinancialProduct.Details.Rules.Details.OutputDictionaries.ValidationList')}</Typography>
          </StyledTableRow>
        )}
      {sequence(outputDictionariesList)?.map((data, index) => {
        return (
          <FinancialProductRulesEditDetailsOutputDictionariesTableRow
            canWrite={canWrite}
            financialProductRuleOutputDictionaryParamList={financialProductRuleOutputDictionaryParamList}
            key={`${index}_${data.financialProductRuleOutputDictionaryId |> get}`}
            dataLens={data}
            index={index}
            onCloseEdit={onCloseEdit}
            onDelete={onDelete}
            onSave={onSave}
            financialProductRuleOutputDictionaryValidation={financialProductRuleOutputDictionaryValidation[index]}
            listValid={isValid(financialProductRuleOutputDictionaryValidation)}
          />
        );
      })}
    </TableBody>
  );
};

FinancialProductRulesEditDetailsOutputDictionariesTableBody.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  financialProductRuleOutputDictionaryParamList: PropTypes.array.isRequired,
  outputDictionariesList: PropTypes.object.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleOutputDictionaryValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsOutputDictionariesTableBody;
